
import { Component } from 'vue-property-decorator';
import Button from '@/components/atoms/Button/Button.vue';

@Component({ components: { Button } })
export default class OutlinedButton extends Button {
  constructor() {
    super();
  }
}
